import { canAtLeast } from '@/auth/capabilities';
import type { User } from '@/api/types.gen';

/**
 * Where `/` sends a signed-in user.
 *
 * Phones land on Campaigns — the operational object planners, executives and
 * admins all touch — falling back to Reports and then Productions for roles
 * that cannot see campaigns (every current role can; the fallbacks are there
 * so a future role never loops). The fallbacks matter: `requireCapability` bounces
 * a denied role back to `/`, so landing on a screen the role cannot open would
 * loop. Wider layouts keep the desktop rule: the Brief when Copilot is on,
 * otherwise the first Backend item.
 */
export function landingFor({ user, phone, copilot }: {
  user: User | undefined;
  phone: boolean;
  copilot: boolean;
}): '/campaigns' | '/reports' | '/backend/productions' | '/brief' {
  if (phone && user) {
    if (canAtLeast(user.role, 'campaigns_view', 'view')) return '/campaigns';
    if (canAtLeast(user.role, 'reports_view', 'view')) return '/reports';
  }
  return copilot ? '/brief' : '/backend/productions';
}
